<template>
  <div class="normal-item">
    <div class="exam-header">
      <span class="exam-name ellipsis">{{ data.name }}</span>
      <span :class="hintCls" class="exam-hint">
        <i :class="hintIconCls" class="exam-hint-icon" />
        <span class="exam-hint-text">{{ hintText }}</span>
      </span>
    </div>
    <div class="exam-time">
      <div class="start-time">
        <i class="exam-time-icon safety-icon-calendar" />
        <span class="exam-time-prefix">开始时间:</span>
        <span class="exam-time-text">{{ data.start_time }}</span>
      </div>
      <div class="end-time">
        <i class="exam-time-icon safety-icon-calendar" />
        <span class="exam-time-prefix">截止时间:</span>
        <span class="exam-time-text">{{ data.end_time }}</span>
      </div>
    </div>
    <div class="exam-operation">
      <div>
        <Button
          v-if="Number(data.exam_status) !== 2||Number(data.is_exam) === 1"
          :disabled="btnDisabled"
          class="detail-btn"
          size="small"
          type="primary"
          style="background: transparent;color: red;cursor:none"
        >
          {{ examStatusName }}
        </Button>
        <Button
          v-if="detailText !== ''&&Number(data.is_exam) !== 1"
          :disabled="btnDisabled"
          class="detail-btn"
          size="small"
          type="primary"
          @click="onDetailClick"
        >
          {{ detailText }}
        </Button>
      </div>
    </div>
    <addorRecoFace v-if="showFaceDialog" @success="faceSuccessFunc" @error="faceErrorFunc" :type="2" @close="showFaceDialog=false" />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import { MessageBox, Message } from "element-ui";
import moment from "moment";
import addorRecoFace from './addorRecoFace.vue'

export default {
  components: {
    addorRecoFace
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showFaceDialog: false,
      now: moment(),
    }
  },
  computed: {
    ...mapState(['userInfo']),
    btnDisabled() {
      const { examStatus, startTime, endTime,is_exam } = this.data;
      const start = moment(startTime);
      const end = moment(endTime);
      const now = this.now;

      if(Number(is_exam) === 1){
        return true;
      }
      if (examStatus === "undo" && start > now) {
        return true;
      } else if (examStatus === "doing" && end < now) {
        return true;
      }
      return false;
    },
    hintCls() {
      const {
        examStatus,
        absent,
        isPass,
        markStatus,
        startTime,
        endTime,
      } = this.data;
      const start = moment(startTime);
      const end = moment(endTime);
      const now = this.now;
      if (examStatus === "undo") {
        if (start > now) {
          return "exam-hint-doing";
        } else {
          return "";
        }
      } else if (examStatus === "doing") {
        if (end > now) {
          return "exam-hint-doing";
        } else {
          return "";
        }
      } else if (examStatus === "done") {
        // 已考试还未阅卷
        if (Number(absent) === 0 && Number(markStatus) === 0) {
          return "exam-hint-done";
        }
        if (Number(absent) === 1 || Number(isPass) === 0) {
          return "exam-hint-error";
        }
        return "exam-hint-done";
      }
      return "";
    },
    hintText() {
      const {
        examStatus,
        startTime,
        endTime,
        absent,
        isPass,
        markStatus,
      } = this.data;
      const start = moment(startTime);
      const end = moment(endTime);
      const now = this.now;

      if (examStatus === "undo") {
        const d = start - now;
        if (d > 0) {
          const duration = moment.duration(d);
          return `距离考试开始还有${this.getDurationStr(duration)}`;
        } else {
          return "";
        }
      } else if (examStatus === "doing") {
        const d = end - now;
        if (d > 0) {
          const duration = moment.duration(d);
          return `距离考试结束还有${this.getDurationStr(duration)}`;
        } else {
          return "";
        }
      } else if (examStatus === "done") {
        if (Number(absent) === 1) {
          return "漏考";
        }
        if (Number(markStatus) === 0) {
          return "待阅卷";
        }
        if (Number(isPass) === 0) {
          return "不合格";
        }
        return "合格";
      }
      return "";
    },
    hintIconCls() {
      const {
        examStatus,
        absent,
        isPass,
        markStatus,
        startTime,
        endTime,
      } = this.data;
      const start = moment(startTime);
      const end = moment(endTime);
      const now = this.now;

      if (examStatus === "undo") {
        if (start > now) {
          return "safety-icon-stop1";
        } else {
          return "";
        }
      } else if (examStatus === "doing") {
        if (end > now) {
          return "safety-icon-time_fill";
        } else {
          return "";
        }
      } else if (examStatus === "done") {
        // 已考试还未阅卷
        if (Number(absent) === 0 && Number(markStatus) === 0) {
          return "safety-icon-radiobutton";
        }
        if (Number(absent) === 1 || Number(isPass) === 0) {
          return "safety-icon-circle-delete";
        }
        return "safety-icon-radiobutton";
      }
      return "";
    },
    examStatusName() {
      const { exam_status, is_exam } = this.data;
      if(Number(is_exam) === 1){
        return '已完成'
      }
      //exam_status 0 考试未开始 1已结束 2进行中
      if (Number(exam_status) === 0) {
        return "未开始";
      } else if (Number(exam_status) === 1) {
        return "已结束";
      } 
      return "";
    },
    detailText() {
        const { exam_status,is_exam } = this.data;

      // exam_status 0 考试未开始 1已结束 2进行中
        if (Number(exam_status) === 2) {
          if(Number(is_exam) === 0){
            return "进入考场";
          }
          
        } 
      return "";
    },
    detailBtnCls() {
      const { examStatus } = this.data;
      if (examStatus === "undo") {
        return "detail-btn-doing";
        // return 'detail-btn-undo';
      } else if (examStatus === "doing") {
        return "detail-btn-doing";
      } else if (examStatus === "done") {
        return "detail-btn-doing";
        // return 'detail-btn-done';
      }
      return "";
    },
    scoreText() {
      const { markStatus, score, absent } = this.data;
      // 漏考分数为0
      if (Number(absent) === 1) {
        return 0;
      }
      if (Number(markStatus) === 1) {
        return score;
      }
      return "待批阅";
    },
    showLocation() {
      const { examStatus } = this.data;
      if (examStatus === "done") {
        return false;
      }
      return true;
    },
    showSimulate() {
      const { simulation, examStatus } = this.data;
      if (Number(simulation) === 1 && examStatus === "undo") {
        return true;
      }
      return false;
    },
    canMakeUp() {
      const { makeUp, absent, isPass, markStatus, examStatus } = this.data;
      // makeUp-补考标记 1-支持补考 0-不支持 examStatus考试状态 done-已完成
      if (Number(makeUp) === 1 && examStatus === "done") {
        // absent是否漏考 1 漏考 0 未漏考
        if (Number(absent) === 1) {
          return true;
        }
        // isPass考试结果 0 不合格 1 合格
        if (Number(isPass) === 0 && Number(markStatus) === 1) {
          return true;
        }
      }
      return false;
    },
  },
  mounted() {
    setInterval(() => {
      this.now = moment();
    }, 1000);
  },
  methods: {
    faceErrorFunc(){
      Message.error('人脸识别不通过')
      this.showFaceDialog = false;
    },
    faceSuccessFunc(){
      Message.success('人脸识别通过')
      this.showFaceDialog = false;
      this.startExamFunc();
    },
    startExamFunc(){
      MessageBox.alert('开始考试时，请允许使用摄像头、麦克风以及分享当前屏幕', '提示', {
          confirmButtonText: '确定',
          callback: async() => {
            if(!this.isBukao){
              localStorage.setItem("rsw_exam_affair_id", this.data.id);
              localStorage.removeItem("rsw_exam_id");
              localStorage.removeItem("rsw_opreate");
              this.$router.push("/exam");
            }else{
              this.$router.push(`/reExam/${this.data.examId}`);
            }
          }
        });
    },
    onSimulationClick() {
      this.$router.push(`/exam/${this.data.examId}/1`);
    },
    viewDetail(affair_id, exam_id) {
      localStorage.removeItem("rsw_opreate");
      localStorage.setItem("rsw_exam_affair_id", affair_id);
      localStorage.setItem("rsw_exam_id", exam_id);
      this.$router.push("/exam");
    },
    onDetailClick() {
      // 非白名单用户需要人脸识别
      if(!this.userInfo.is_white){
        if(this.userInfo.is_face===0){
          Message.warning('请点击右上角按钮录入人脸数据')
          return false;
        }
        this.isBukao = false
        this.showFaceDialog = true
      }else{
        this.startExamFunc();
      }
      
    },
    onMakeUpClick() {
      MessageBox.confirm(
        "补考将会覆盖之前的成绩，确认无误后点击下面按钮【开始补考】。",
        "补考",
        {
          confirmButtonText: "开始补考",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        if(this.userInfo.is_face===0){
          Message.warning('请点击右上角按钮录入人脸数据')
          return false;
        }
        this.isBukao = true
        this.showFaceDialog = true
        
      });
    },
    getDurationStr(duration) {
      const days = duration.asDays();
      if (days < 0) {
        return "0天0时0分";
      }
      return `${Math.floor(
        days
      )}天${duration.hours()}时${duration.minutes()}分${duration.seconds()}秒`;
    },
  },
};
</script>

<style lang="scss" scoped>
.normal-item {
  height: 100px;
  .exam-header {
    margin-top: 15px;
    font-size: 14px;
    color: #454545;
    display: flex;
    justify-content: space-between;
    .exam-name {
      font-weight: bold;
    }
    .exam-hint {
      margin-right: 20px;
      &-undo {
        color: #faa725;
      }
      &-doing {
        color: #6696ff;
      }
      &-done {
        color: #67af00;
      }
      &-error {
        color: #f21d26;
      }
      &-icon {
        font-size: 14px;
      }
    }
  }

  .exam-time {
    margin-top: 20px;
    font-size: 14px;
    text-align: top;
    line-height: 14px;
    .start-time,
    .end-time {
      display: inline-block;
      width: 242px;
    }
    &-icon {
      color: #4c85ff;
      font-size: 14px;
    }
    &-prefix {
      margin-left: 10px;
      color: #454545;
    }
    &-text {
      margin-left: 10px;
      color: #808080;
    }
  }

  .exam-operation {
    display: flex;
    margin-top: 15px;
    align-items: center;
    flex-direction: row-reverse;
    .exam-location {
      span {
        cursor: pointer;
      }
      flex: 1;
      &-icon {
        color: #4c85ff;
        font-size: 14px;
      }
      &-prefix {
        margin-left: 10px;
        color: #454545;
      }
      &-text {
        margin-left: 10px;
        color: #808080;
      }
    }
    .exam-teacher {
      width: 232px;
      &-icon {
        color: #4c85ff;
        font-size: 14px;
      }
      &-prefix {
        margin-left: 10px;
        color: #454545;
      }
      &-text {
        margin-left: 10px;
        color: #808080;
      }
    }
    .exam-score {
      flex: 1;
      &-icon {
        color: #4c85ff;
        font-size: 14px;
      }
      &-prefix {
        margin-left: 10px;
        color: #454545;
      }
      &-text {
        margin-left: 10px;
        color: #808080;
      }
    }
    .detail-btn {
      background: #6696ff;
      border-radius: 13px;
      padding: 7px 16px;
      border: none;
      color: #fff;
      font-size: 12px;
      margin-right: 20px;
      align-self: flex-end;
      &-undo {
        background: #faa725;
      }
      &-doing {
        background: #6696ff;
      }
      &-done {
        background: #67af00;
      }
      &-make-up {
        background: #f21d26;
      }
      &:disabled {
        background: rgba(102, 150, 255, 0.5);
      }
    }
    .simulation-btn {
      background: #6696ff;
      border-radius: 13px;
      padding: 7px 16px;
      border: none;
      color: #fff;
      font-size: 12px;
      margin-right: 20px;
    }
    .result-btn {
      background: #71ac24;
      border-radius: 13px;
      padding: 7px 16px;
      border: none;
      color: #fff;
      font-size: 12px;
      margin-right: 20px;
    }
  }
}
</style>
